import { render, staticRenderFns } from "./WalletPasswordModal.vue?vue&type=template&id=6872bf34&scoped=true&"
import script from "./WalletPasswordModal.vue?vue&type=script&lang=js&"
export * from "./WalletPasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./WalletPasswordModal.vue?vue&type=style&index=0&id=6872bf34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6872bf34",
  null
  
)

export default component.exports